import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const PoliticsEntertainment = () => {
  return (
    <SportsLayoutComp name={'Politics & Entertainment'}/>
  )
}

export default PoliticsEntertainment